import { ModalWrapper } from './ModalWrapper';

type Props = {
  message?: string;
  disabledBtns?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export const ConfirmDeleteModal = ({ onClose, onConfirm, message, disabledBtns}: Props) => (
  <ModalWrapper onClose={onClose} contentWrappesClassName="w-[350px] max-w-[100%] bg-secondary p-6 rounded border border-gray-700">
    <p className="text-base mb-6 text-left">{message}</p>
    <div className="w-full flex items-center justify-between gap-2">
      <button type="button" className="btn contained primary flex-1" disabled={disabledBtns} onClick={onConfirm}>
        Delete
      </button>
      <button type="button" className="btn flex-1" disabled={disabledBtns} onClick={onClose}>
        Cancel
      </button>
    </div>
  </ModalWrapper>
);
